import React, { useContext } from 'react';
import { useLocalization } from 'gatsby-theme-i18n';
import ModalContext from 'contexts/ModalContext';
import styled from 'styled-components';
import checkIcon from 'browser/assets/icons/check.svg';

export const TERMS = {
  pl: [
    {
      formTermsText: 'Akceptuję ogólne warunki użytkowania i',
      privacyPolicy: 'politykę prywatności',
    },
  ],
  en: [
    {
      formTermsText: 'I accept the general terms of use and',
      privacyPolicy: 'privacy policy',
    },
  ],
  de: [
    {
      formTermsText: 'Ich akzeptiere die Allgemeinen Nutzungsbedingungen und',
      privacyPolicy: 'Datenschutzbestimmungen',
    },
  ],
};

export const Label = styled.label`
  display: flex;
  align-items: center;
  position: relative;
  padding-left: 27px;
  margin: 10px 0;
  cursor: pointer;
  font-size: 1.2rem;
  text-align: left;
  &:first-of-type {
    margin-bottom: 13px;
  }
`;

const LabelText = styled.p`
  button {
    display: inline-block;
    border: none;
    background: transparent;
    color: ${({ theme }) => theme.colors.white};
    padding: 0;
    margin: 0;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
`;

export const Checkmark = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  height: ${({ big }) => (big ? '25px' : '20px')};
  width: ${({ big }) => (big ? '25px' : '20px')};
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid;
  transition: 0.2s;
  border-color: ${({ theme, error }) =>
    error ? theme.colors.red : theme.colors.gray100};
  &:after {
    content: '';
    position: absolute;
    opacity: 0;
    transition: 0.2s;
    left: ${({ big }) => (big ? '6px' : '3px')};
    top: ${({ big }) => (big ? '5px' : '3px')};
    width: 12px;
    height: 12px;
    background: url(${checkIcon}) no-repeat center;
  }
`;

export const Checkbox = styled.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
  &:checked ~ ${Checkmark} {
    background: ${({ theme }) => theme.colors.primaryLight};
    border-color: ${({ theme }) => theme.colors.primaryLight};
    &:after {
      opacity: 1;
    }
  }
`;

const Terms = ({ setFieldValue, values, setErrors, errors, submitClicked }) => {
  const { locale } = useLocalization();
  const { showModal } = useContext(ModalContext);

  const finalTerms = TERMS[locale].map(
    ({ formTermsText, privacyPolicy }, index) => ({
      name: `agree${index + 1}`,
      content: formTermsText,
      policy: privacyPolicy,
      required: index === 0,
    })
  );

  const agree1Key = 'agree1';

  return (
    <>
      {finalTerms.map(({ name, content, policy, required }) => (
        <Label htmlFor={name} key={name}>
          <LabelText>
            {content}{' '}
            {policy && (
              <button onClick={showModal} type="button">
                {policy}
              </button>
            )}
          </LabelText>
          <Checkbox
            id={name}
            type="checkbox"
            onChange={() => {
              setFieldValue(name, !values[name]);
              required && setErrors({ ...errors, [agree1Key]: '' });
            }}
            checked={values[name]}
          />
          <Checkmark
            error={
              submitClicked &&
              errors[agree1Key] &&
              required &&
              values[name] === false
            }
          />
        </Label>
      ))}
    </>
  );
};

export default Terms;
